module.exports = __webpack_public_path__ + "static/media/HT_Video_Placeholder_Image.5ec392db.png";